module.exports = __webpack_public_path__ + "static/media/collage_3.a90b2550.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/collageGame/collage_3.jpg
// module id = 2257
// module chunks = 0